"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var $ = require("jquery");
require("jquery-form");
/** Multi-part data form validator */
var Form = /** @class */ (function () {
    function Form($form, callback, submitCallback) {
        var _this = this;
        if (submitCallback === void 0) { submitCallback = null; }
        this.watchers = function () {
            _this.$form.on('submit', _this.onSubmit);
        };
        this.onSubmit = function (e) {
            e.preventDefault();
            _this.$form.ajaxSubmit({
                beforeSubmit: function () {
                    if (typeof _this.submitCallback == 'function') {
                        _this.submitCallback();
                    }
                },
                success: function (response) {
                    if (response.status === 'error') {
                        _this.showErrors(response.messages);
                    }
                    _this.callback(response, response.status);
                },
            });
        };
        this.showErrors = function (errorMessages) {
            _this.$form.find('.error-visible').removeClass('error-visible');
            _this.$form.find('.field-error').removeClass('field-error');
            _this.$form.find('.field__error').remove();
            Object.keys(errorMessages).forEach(function (key) {
                var $key1 = key.substr(0, key.indexOf('.')), $key2 = key.substr(key.indexOf('.') + 1), $key = $key1 + '[' + $key2 + ']', $input = $('[name="' + $key + '"]'), $field = $input.closest('.field'), $errorField = $field.find('.field__error');
                if (!$errorField.length) {
                    $field.append('<div class="field__error">');
                    $errorField = $field.find('.field__error');
                }
                $errorField.html(errorMessages[key]).addClass('error-visible');
                $input.addClass('field-error');
            });
        };
        this.clearErrors = function ($field) {
            $field.find('.error-visible').removeClass('error-visible');
            $field.find('.field-error').removeClass('field-error');
            $field.find('.field__error').remove();
        };
        this.$form = $form;
        this.url = this.$form.attr('action');
        this.callback = callback;
        this.submitCallback = submitCallback;
        this.watchers();
    }
    return Form;
}());
exports.Form = Form;
